import React, { useState } from "react";
import Input from "../../ui/input/Input";
import Button from "../../ui/button/button";
import "./joinWaitlist.css";
// 1. Import your service and the payload type
import { createSubscription, SubscriptionRequest } from "../../services/subscription";

const JoinWaitlist: React.FC = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // New state to manage loading state
  const [submitted, setSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // Track API response text dynamically

  const validateEmail = (value: string) => {
    if (!value.trim()) {
      return "Please enter your email address.";
    }

    if (!value.includes("@")) {
      return "Email must contain @";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(value)) {
      return "Please enter a valid email address.";
    }

    return "";
  };

  // 2. Make the submit handler asynchronous
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationError = validateEmail(email);

    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setLoading(true); // Disable button/show loader

    try {
      // 3. Prepare payload and call the API
      const payload: SubscriptionRequest = {
        email: email.trim(),
        type: "waitlist", // Hardcoded based on the component's goal
      };

      const result = await createSubscription(payload);
      
      // Update message based on whether they are completely new (201) or already signed up (200)
      setSuccessMessage(result.message);
      setSubmitted(true);
    } catch (apiError: any) {
      // 4. Handle backend/network communication failures gracefully
      setError(
        apiError?.message || "Something went wrong on our end. Please try again later."
      );
    } finally {
      setLoading(false); // Re-enable button
    }
  };

  if (submitted) {
    return (
      <div className="waitlist-panel" aria-label="Join waitlist panel">
        <h3 className="waitlist-title">Thank You!</h3>
        <p className="waitlist-description">
          {successMessage || "You've successfully joined the waitlist. We'll keep you updated."}
        </p>
      </div>
    );
  }

  return (
    <div className="waitlist-panel" aria-label="Join waitlist panel">
      <h3 className="waitlist-title">Early Access</h3>

      <p className="waitlist-description">
        Your AI enabled brand manager is coming
      </p>

      <form className="waitlist-form" onSubmit={handleSubmit}>
        <Input
          type="email"
          className="input-element"
          placeholder="Enter your email address"
          aria-label="Email address"
          value={email}
          disabled={loading} // Prevent typing while processing
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(e.target.value);

            if (error) {
              setError("");
            }
          }}
        />

        {/* 5. Dynamically change text or disable the button during loading states */}
        <Button type="submit" className="waitlist-button" disabled={loading}>
          {loading ? "Joining..." : "Join Waitlist"}
        </Button>
      </form>

      {error && <p className="waitlist-error">{error}</p>}
    </div>
  );
};

export default JoinWaitlist;